import React from 'react';
import {Box, CircularProgress, Theme, Tooltip} from "@mui/material";
import {SubTitle, Title} from "./typography";
import {SxProps} from "@mui/system/styleFunctionSx";
import InfoSvg from '../assets/images/info.svg';
import WarningSvg from "../assets/images/warningSvg";

interface ChartCardProps {
  title: string;
  subtitle?: string;
  subtitle_element?: any;
  info?: string;
  warning?: string;
  loading?: number;
  children: React.ReactElement;
  sx?: SxProps<Theme>;
}

export function ChartCard(props: ChartCardProps) {
  const { title, subtitle, subtitle_element, info, warning, loading, children, sx, ...rest } = props;
  
  return <Box {...rest}
              sx={{
                borderRadius: 3,
                border: (theme: any) => "1px solid " + theme.palette.background.border,
                backgroundColor: "white", ...sx
              }}>
    <Box display="flex" flexDirection="column" pb={2}>
      <Box display="flex" flexDirection="row" gap={1} alignItems="center">
        {title ? <Title sx={{color: (theme: any) => theme.palette.text.primary}}>{title}</Title> : null}
        {info && <Tooltip title={info}><img width={15} src={InfoSvg}/></Tooltip>}
        {warning && <Tooltip title={warning}><Box width={20} display="flex" alignContent="center"><WarningSvg fill="#FFAA00"/></Box></Tooltip>}
        {loading == 1 && <CircularProgress size={18}/>}
      </Box>
      {subtitle ? <SubTitle
        sx={{color: (theme: any) => theme.palette.text.tertiary, width: '100%'}}>{subtitle}</SubTitle> : null}
      {subtitle_element}
    </Box>
    {children}
  </Box>
}